import blueArrow from "../../assets/images/svg/blueArrow.svg";

const AToZ = ({ fontSize, isSort, isSorting, arrowHeight, className = "" }) => {
  const sortState =
    isSort === "asc"
      ? { btnLabel: "A to Z", order: "ascending order" }
      : { btnLabel: "Z to A", order: "descending order" };

  return (
    <>
      <button
        aria-describedby="sort-state"
        className={`filter darkBlueTextColor ${
          isSort === "asc" ? "asc_filtered" : ""
        } ${isSorting ? "is-sorting" : ""} ${className}`}
        style={{
          fontSize: fontSize || "16px",
          border: "none",
          padding: "0",
          background: "transparent",
        }}
        aria-label={`${sortState.btnLabel} sort`}
      >
        <img
          className={!arrowHeight ? "arrowHeightOrigin" : arrowHeight}
          src={blueArrow}
          alt=""
        />{" "}
        <p> {sortState.btnLabel}</p>
      </button>

      <span id="sort-state" className="sr-only">
        {sortState.order}
      </span>
    </>
  );
};

export default AToZ;
